import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import GlobalLoader from '../components/context/GlobalLoader';

export default function AccountGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      /* ===============================
         1) AUTH
      =============================== */
      const {
        data: { session },
        error: authError,
      } = await supabase.auth.getSession();

      if (cancelled) return;

      if (authError || !session?.user) {
        navigate('/login', { replace: true });
        return;
      }

      const user = session.user;

      /* ===============================
         2) PAID ACCOUNT EXISTS CHECK
         ✅ Stripe success => subscription row exists
         ❌ Google-only users => no subscription row
      =============================== */
      const { data: subscription, error: subError } = await supabase
        .from('subscriptions')
        .select('id')
        .eq('user_id', user.id)
        .maybeSingle();

      if (cancelled) return;

      if (subError) {
        await supabase.auth.signOut();
        navigate('/login?error=no_account_found', { replace: true });
        return;
      }

      // No plan yet is a free account now (2026-10-05). Onboarding comes
      // after payment, so send them back and let AppGate route them.
      if (!subscription) {
        navigate('/', { replace: true });
        return;
      }

      /* ===============================
         ✅ ALLOW ACCESS
      =============================== */
      setLoading(false);
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (loading) return <GlobalLoader message="Verifying your membership…" />;

  return <>{children}</>;
}
